import { useState, useRef } from "react"

import Style from "./style"
import checkIcon from "./asset/check.svg"
import checkedIcon from "./asset/checked.svg"

import MainHeader from "widget/MainHeader"

import usePostImgUpload from "entity/util/usePostImgUpload"
import usePostVideoUpload from "entity/util/usePostVideoUpload"
import usePostAdvertise from "entity/advertiseTimer/usePostAdvertise"

import CStyle from "shared/style/commonStyle"
import DefaultButton from "shared/ui/DefaultButton"

const AdTimerCreate = () => {
    const srcRef = useRef()
    const videoRef = useRef()

    const [tab, setTab] = useState("image")

    const [src, uploadSrcEvent, deleteSrcEvent] = usePostImgUpload()
    const [video, uploadVideoEvent, deleteVideoEvent] = usePostVideoUpload()
    const [postAdvertise] = usePostAdvertise(src, video, tab)

    const btnList = [
        {
            "label": "생성",
            "clickEvent": () => postAdvertise(),
            "deactive": false
        }
    ]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            <Style.AreaDiv>
                <h2>타이머 광고 종류<span>*</span></h2>
                <Style.RadioDiv>
                    <button onClick={() => setTab("image")}>
                        <img src={tab === "image" ? checkedIcon : checkIcon} /> 이미지
                    </button>
                    <button onClick={() => setTab("video")}>
                        <img src={tab === "video" ? checkedIcon : checkIcon} /> 비디오
                    </button>
                </Style.RadioDiv>
            </Style.AreaDiv>

            {tab === "image" &&
                <Style.AreaDiv>
                    <h2>이미지 첨부파일<span>*</span></h2>
                    <CStyle.GuideDiv>
                        <p>jpg, png 이미지 | 20mb 제한</p>
                    </CStyle.GuideDiv>
                    <DefaultButton small fitWidth clickEvent={() => srcRef.current.click()}>첨부하기</DefaultButton>
                    <input type="file" ref={srcRef} onChange={uploadSrcEvent} style={{ display: "none" }} />

                    <Style.ImgUploadDiv>
                        {src &&
                            <Style.ImgElement>
                                <button onClick={deleteSrcEvent}>삭제</button>
                                <img src={src} onClick={() => window.open(src, "_blank")} />
                            </Style.ImgElement>
                        }
                    </Style.ImgUploadDiv>
                </Style.AreaDiv>
            }

            {tab === "video" &&
                <Style.AreaDiv>
                    <h2>동영상 첨부파일<span>*</span></h2>
                    <CStyle.GuideDiv>
                        <p>avi, mp4, wmv 동영상 | 50mb 제한</p>
                    </CStyle.GuideDiv>
                    <DefaultButton small fitWidth clickEvent={() => videoRef.current.click()}>첨부하기</DefaultButton>
                    <input type="file" ref={videoRef} onChange={uploadVideoEvent} style={{ display: "none" }} />

                    <Style.ImgUploadDiv>
                        {video &&
                            <Style.ImgElement>
                                <button onClick={deleteVideoEvent}>삭제</button>
                                <video src={video} controls />
                            </Style.ImgElement>
                        }
                    </Style.ImgUploadDiv>
                </Style.AreaDiv>
            }

        </Style.Wrapper>
    )
}

export default AdTimerCreate